export default __webpack_public_path__ + "static/media/cuspom-pointer.1eabe3ec.svg";